import { jsx as _jsx } from "react/jsx-runtime";
import { TableSortLabel as MuiTableSortLabel } from '@material-ui/core';
import { withDefaultPropsAndStyles } from '../utils';
import { LongArrowDownIcon } from '../Icon';
const StyledArrowDownIcon = withDefaultPropsAndStyles('StyledArrowDownIcon', LongArrowDownIcon, {
    styles: ({ typography }) => ({
        root: {
            fontSize: typography.pxToRem(18),
        },
    }),
});
export const TableSortLabel = withDefaultPropsAndStyles('TableSortLabel', MuiTableSortLabel, {
    defaultProps: {
        IconComponent: ({ className }) => _jsx(StyledArrowDownIcon, { className: className }, void 0),
    },
    styles: () => ({
        icon: {},
    }),
});
export { Table, TableRow, TableCell, TableContainer, TableHead, TableBody, TablePagination } from '@material-ui/core';
//# sourceMappingURL=Table.js.map